import { ThemeProvider } from "@mui/material";
import { DynamicMuiTheme } from "Global/Functions/DynamicMuiTheme";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
import React, { createContext, useState } from "react";

export const ThemeContext = createContext();

export const MuiProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    DynamicMuiTheme(themeColors.ColorPrimary, themeColors.ColorSecondary)
  );

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
